module.exports = __webpack_public_path__ + "static/easyeducation-extraimg1-min-3dbf6b098bf5608b841ea5158e50496f.jpg";